import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@phosphor-icons/react';

import icon from 'assets/images/emessage-logo.png';
import MasterWallet from 'emessage/components/MasterWallet';
import HeaderProfile from './components/HeaderProfile';

/*
 * 64px, was 94px. shadow-lg is gone: a 1px neutral-200 bottom border picks up
 * the sidebar masthead's hairline so the two run unbroken across the top.
 *
 * At xl and up the wordmark lives in the sidebar masthead; below xl the rail
 * collapses to a slide-over and the brand moves here.
 */
function Header({ isOpen, setIsOpen }) {
  return (
    <header className="relative flex-shrink-0 h-header flex items-center bg-white border-b border-neutral-200 z-40">
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        aria-label="Open navigation"
        className="h-full px-4 border-r border-neutral-200 text-neutral-500 hover:bg-neutral-100 hover:text-neutral-900 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-600 xl:hidden"
      >
        <List size={20} />
      </button>
      <div className="flex-grow flex justify-between items-center gap-4 px-4">
        <figure className="xl:hidden">
          <img className="h-8 w-auto" src={icon} alt="eMessage Core" />
        </figure>
        <div className="hidden xl:block" />
        <div className="flex items-center gap-4">
          <MasterWallet />
          <HeaderProfile />
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default Header;
